module.exports = __webpack_public_path__ + "img/u3.ebecfd3b.jpg";